import { GetInterfaceValidatorConfigResponseObj } from "@/types/interfaces/crm";
import axiosInstance from "../axiosInstance";

const INTERFACE_VALIDATOR_CONFIG_KEY = "INTERFACE_VALIDATOR_CONFIG";

export async function getInterfaceValidatorConfig(): Promise<GetInterfaceValidatorConfigResponseObj> {
  const res = await axiosInstance.get(`/crm/admin/configs/${INTERFACE_VALIDATOR_CONFIG_KEY}`);
  const { data } = res.data;
  return {
    data,
  };
}
